import React from 'react';

const Select = ({ children, ...props }) => {
  const { label, className } = props;

  return (
    <div
      className={`bg-yellow-30 font-crystalCondensed mb-2 lg:mb-0 ${className}`}
    >
      <label
        className="text-xxs px-3 w-full text-black-50 absolute top-1"
        htmlFor={label}
      >
        {label}
      </label>
      {children}
    </div>
  );
};

export default Select;
